import { Directive, EmbeddedViewRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserRole } from 'src/app/core/enums/UserRole';
import { UserPermissionsService } from 'src/app/core/services/user-permissions.service';

@Directive({
  selector: '[craftRole]',
  standalone: false,
})
export class CraftRoleDirective {
  private role: UserRole;
  private inverse = false;

  private elseTemplateRef: TemplateRef<any> | null;
  private thenViewRef: EmbeddedViewRef<any> | null = null;
  private elseViewRef: EmbeddedViewRef<any> | null = null;

  constructor(
    private ups: UserPermissionsService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  @Input()
  public set craftRole(role: string) {
    if (role.startsWith('!')) {
      role = role.slice(1);
      this.inverse = true;
    }
    this.role = (UserRole as any)[role];
    this.thenViewRef = null; // clear previous view if any.
    this.checkPermission();
  }

  @Input()
  set craftRoleElse(templateRef: TemplateRef<any> | null) {
    this.elseTemplateRef = templateRef;
    this.elseViewRef = null; // clear previous view if any.
    this.checkPermission();
  }

  private checkPermission() {
    let isPermitted = this.ups.authorizeStrict(this.role);
    if (this.inverse) {
      isPermitted = !isPermitted;
    }

    this.updateTemplate(isPermitted);
  }

  private updateTemplate(isPermitted: boolean) {
    if (isPermitted) {
      if (!this.thenViewRef) {
        this.elseViewRef = null;
        this.viewContainer.clear();
        this.thenViewRef = this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      if (!this.elseViewRef) {
        this.thenViewRef = null;
        this.viewContainer.clear();
        if (this.elseTemplateRef) {
          this.elseViewRef = this.viewContainer.createEmbeddedView(this.elseTemplateRef);
        }
      }
    }
  }
}
